import {ApiDelete, ApiGetRaw, ApiPatch, ApiPostRaw} from "../../../shared/services/api-service";
import testsCommitTypes from "./commit-types";
import store from "../index";

export default {
  fetchTestsForUser(guid) {
    return (dispatch) => {
      return ApiGetRaw(`/api/v1/user-tests/${guid}`)
        .then(data => {
          dispatch({
            type: testsCommitTypes.SET_TESTS,
            list: data
          })
        })
    }
  },
  fetchMyTests() {
    return (dispatch) => {
      return ApiGetRaw(`/api/v1/my-tests`)
        .then(data => {
          dispatch({
            type: testsCommitTypes.SET_TESTS,
            list: data
          })
        })
    }
  },
  fetchTestsForGrade() {
    if (store.getState().common.userContext.scope === 'oit') {
      return () => {
      }
    }

    return (dispatch) => {
      return ApiGetRaw(`/api/v1/test-grade`)
        .then(data => {
          dispatch({
            type: testsCommitTypes.SET_TESTS_FOR_GRADE,
            list: data
          })
        })
    }
  },
  createTest(form) {
    return (dispatch) => {
      return ApiPostRaw(`/api/v1/test-schedule`, form)
        .then(data => {
        })
    }
  },
  deleteTest(testId) {
    return (dispatch) => {
      return ApiDelete(`/api/v1/test-schedule/` + testId)
        .then(data => {
          dispatch({
            type: testsCommitTypes.DELETE_TEST,
            testId: testId
          })
        })
    }
  },
  startTest(form) {
    return (dispatch) => {
      return ApiPostRaw(`/api/v1/test`, form)
        .then(data => {
          dispatch({
            type: testsCommitTypes.START_TEST,
            test: data
          })
        })
    }
  },
  gradeAnswer(form) {
    return (dispatch) => {
        return ApiPatch(`/api/v1/test-grade/${form.id}`, {
          answer: form.question.id,
        line: form.lineIndex,
        grade: form.grade
      })
        .then(data => {
          dispatch({
            type: testsCommitTypes.GRADE_TEST,
            test: data
          })
        })
    }
  },

  finishGradeTest(id) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/test-grade/finish/${id}`)
        .then(data => {
          dispatch({
            type: testsCommitTypes.GRADE_TEST,
            test: data
          })
        })
    }
  },

  submitTest(form, id) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/test/${id}`, form)
        .then(data => {
          dispatch({
            type: testsCommitTypes.UPDATE_TEST,
            test: data
          })
        })
    }
  },
  finishTest(form) {
    return (dispatch) => {
      return ApiPostRaw(`/api/v1/test/finish`, form)
        .then(data => {
          dispatch({
            type: testsCommitTypes.FINISH_TEST,
            test: data
          })
        })
    }
  },
  retryTest(form) {
    return (dispatch) => {
      return ApiPostRaw(`/api/v1/test/retry`, form)
        .then(data => {
          dispatch({
            type: testsCommitTypes.RETRY_TEST,
            test: data
          });

          return data;
        })
    }
  }
}
